import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http'
import { finalize, Observable } from 'rxjs'
import { Injectable } from '@angular/core'
import { LoaderService } from 'src/app/shared/loader/loader.service'

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Verificar se a requisição deve ignorar o loading global
    if (req.headers.has('X-Skip-Loader')) {
      const modifiedReq = req.clone({
        headers: req.headers.delete('X-Skip-Loader')
      });
      return next.handle(modifiedReq);
    }
    
    this.loaderService.show()
    return next.handle(req).pipe(finalize(() => this.loaderService.hide()))
  }
}
